import React from "react";
import Input from "../../../../components/Input";
import CheckCircle from "@material-ui/icons/CheckCircle";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { getFullCloudFrontURL } from "../../../../utils/Constants";

function FlashCardAnswerView({
  isViewMode,
  values,
  flashcard,
  flashcardIndex
}) {
  const { messages } = useIntl();

  const {
    finalTest: { answerText }
  } = messages;

  return (
    <div>
      <div className=" show active">
        {flashcard?.flashcard_options_attributes?.map(
          (answer, answerIndex) => {
            return (
              !answer._destroy && (
                <div
                  className="mx-5 d-flex align-items-center"
                  key={answer.id || answerIndex}
                >
                  <span className="mb-2 mr-1 ">
                    {answerIndex + 1} -
                  </span>
                  <div className="flex-fill ml-1 d-flex align-items-center">
                    {answer.flashcard_attachments_attributes?.[0]
                      ?.path && (
                      <div className="pb-0">
                        <img
                          src={getFullCloudFrontURL(
                            answer
                              .flashcard_attachments_attributes?.[0]
                              ?.path
                          )}
                          alt="medblend"
                          width="100px"
                          className={`img-thumbnail m-3 img`}
                        />
                      </div>
                    )}
                    {answer.content && (
                      <div className="flex-fill">
                        <Input
                          isDisabled={isViewMode}
                          name={`flashcards[${flashcardIndex}].flashcard_options_attributes[${answerIndex}].content`}
                          label={answerText}
                          isRequired={false}
                        />
                      </div>
                    )}
                    {values.flashcards[flashcardIndex]
                      .flashcard_options_attributes[answerIndex]
                      .correct && (
                      <span
                        className={`icon alert alert-success`}
                        role="alert"
                      >
                        <CheckCircle
                          color="success"
                          className="me-2"
                        />
                      </span>
                    )}
                  </div>
                </div>
              )
            );
          }
        )}
      </div>
    </div>
  );
}

FlashCardAnswerView.propTypes = {
  isViewMode: PropTypes.bool.isRequired,
  values: PropTypes.shape({
    flashcards: PropTypes.arrayOf(
      PropTypes.shape({
        flashcard_options_attributes: PropTypes.arrayOf(
          PropTypes.shape({
            correct: PropTypes.bool,
            content: PropTypes.string,
            option_image: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.shape({ url: PropTypes.string })
            ]),
            _destroy: PropTypes.bool
          })
        )
      })
    )
  }).isRequired,
  flashcard: PropTypes.shape({
    flashcard_options_attributes: PropTypes.arrayOf(
      PropTypes.shape({
        correct: PropTypes.bool,
        content: PropTypes.string,
        option_image: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({ url: PropTypes.string })
        ]),
        _destroy: PropTypes.bool
      })
    )
  }).isRequired,
  flashcardIndex: PropTypes.number.isRequired
};

export default FlashCardAnswerView;
